import { render, staticRenderFns } from "./IncidenceDetailModal.vue?vue&type=template&id=182779f0&scoped=true"
import script from "./IncidenceDetailModal.vue?vue&type=script&lang=js"
export * from "./IncidenceDetailModal.vue?vue&type=script&lang=js"
import style1 from "./IncidenceDetailModal.vue?vue&type=style&index=1&id=182779f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182779f0",
  null
  
)

export default component.exports